module.exports = __webpack_public_path__ + "img/toplogo.3a786071.png";